import {
  FETCH_SHIPPING_HOLIDAYS_REQUEST,
  FETCH_DAYS_SHIPPING_REQUEST,
  ADD_SHIPPING_HOLIDAYS_REQUEST,
  ADD_WEEKDAYS_REQUEST,
  FETCH_SHIPPING_HOLIDAYS_SUCCESS,
  FETCH_DAYS_SHIPPING_SUCCESS,
  FETCH_NON_DELIVERY_DAYS_REQUEST,
  FETCH_NON_DELIVERY_DAYS_SUCCESS,
  ADD_NON_DELIVERY_DAYS_REQUEST,
} from 'constants/index';

import {
  IHolidayFormFields,
  IRequestAddHolidayDate,
} from 'containers/application-manager/holidays/interface';

import {
  IDayAreaShipping,
  IRequestAddWeekday,
} from 'containers/application-manager/day-area-shipping/day-area-shipping.interface';
import HTTP from 'services/http';
import { INonDeliveryDays } from 'containers/application-manager/non-delivery-days/non-delivery-days.interface';

export const fetchShippingHolidaysRequest = (customerId: number) => ({
  type: FETCH_SHIPPING_HOLIDAYS_REQUEST,
  payload: HTTP.get(`/shipping/customer/${customerId}/holidays`, {}),
});

export const fetchDaysShippingRequest = (customerId: number) => ({
  type: FETCH_DAYS_SHIPPING_REQUEST,
  payload: HTTP.get(`/area_shipping/customer/${customerId}/days_shipping`, {}),
});

export const fetchNonDeliveryDaysRequest = (customerId: number) => ({
  type: FETCH_NON_DELIVERY_DAYS_REQUEST,
  payload: HTTP.get(`/non_delivery_days/${customerId}`, {}),
});

export const fetchShippingHolidaysSuccess = (payload: any) => ({
  type: FETCH_SHIPPING_HOLIDAYS_SUCCESS,
  payload,
});

export const fetchDaysShippingSuccess = (payload: any) => ({
  type: FETCH_DAYS_SHIPPING_SUCCESS,
  payload,
});

export const fetchNonDeliveryDaysSuccess = (payload: any) => ({
  type: FETCH_NON_DELIVERY_DAYS_SUCCESS,
  payload,
});

export const addShippingHoliday = (
  { holidayDate, holidayTypes }: IHolidayFormFields,
  customerId: number,
) => {
  const data: IRequestAddHolidayDate = {
    date: holidayDate,
    holidayTypes,
    customerId,
  };

  const request = HTTP.post('/shipping/customer/holidays', data);
  return {
    type: ADD_SHIPPING_HOLIDAYS_REQUEST,
    payload: request,
    customerId,
  };
};

export const addWeekday = ({ weekday, zipCodes }: IDayAreaShipping, customerId: number) => {
  const data: IRequestAddWeekday = {
    weekday,
    zipCodes,
    customerId,
  };

  const request = HTTP.post('/area_shipping/customer/weekday', data);
  return {
    type: ADD_WEEKDAYS_REQUEST,
    payload: request,
    customerId,
  };
};

export const addNonDeliveryDays = ({ customerId, ...data }: INonDeliveryDays) => {
  const request = HTTP.post(`/non_delivery_days/${customerId}`, data);
  return {
    type: ADD_NON_DELIVERY_DAYS_REQUEST,
    payload: request,
    customerId,
  };
};
